/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const METRO2Comment = ({
    getMETRO2User, metro2Comment, setMETRO2Comment, commentLoading, addMETRO2Comment,
    loading, getUserCommentsForMetro2, metro2Edit, handleMETRO2Click, metro2Show,
    metro2Target, onMetro2EditClick, onMETRO2ClickDelete, metro2SelectedIndex,
    metro2SelectedComment, setMETRO2SelectedComment, onMETRO2CancelClick, onMETRO2ClickSave,
}) => (
    <CommentsSection
        getUser={getMETRO2User}
        comment={metro2Comment}
        setComment={setMETRO2Comment}
        commentLoading={commentLoading}
        addComment={addMETRO2Comment}
        loading={loading}
        getUserComments={getUserCommentsForMetro2}
        edit={metro2Edit}
        handleClick={handleMETRO2Click}
        show={metro2Show}
        target={metro2Target}
        onEditClick={onMetro2EditClick}
        onClickDelete={onMETRO2ClickDelete}
        selectedIndex={metro2SelectedIndex}
        selectedComment={metro2SelectedComment}
        setSelectedComment={setMETRO2SelectedComment}
        onCancelClick={onMETRO2CancelClick}
        onClickSave={onMETRO2ClickSave}
    />
);

export default METRO2Comment;
